// src/reducers/commerce_admin_reducers.js
import {
  CA_ORDERS_LOADING, CA_ORDERS_SUCCESS, CA_ORDERS_FAIL,
  CA_ORDER_LOADING, CA_ORDER_SUCCESS, CA_ORDER_FAIL,
  CA_ACTION_LOADING, CA_ACTION_SUCCESS, CA_ACTION_FAIL,
  CA_ADMIN_LOADING, CA_ADMIN_PRODUCTS, CA_ADMIN_PAGES, CA_ADMIN_VOUCHERS, CA_ADMIN_FAIL,
  CA_US_VOUCHERS,
  CA_INDIA_VOUCHERS,
  CA_VOUCHER_PRODUCTS,
  CA_ADMIN_SAVING, CA_ADMIN_SAVED, CA_ADMIN_SAVE_FAIL,
  CA_PRODUCT_LOADING, CA_PRODUCT_SUCCESS, CA_PRODUCT_FAIL, CA_PRODUCT_SAVING, CA_PRODUCT_SAVED,
} from "../actions/commerce_admin_actions";

const initial = {
  orders: [],
  pageInfo: { hasNextPage: false, endCursor: null },
  totalCount: 0,
  ordersLoading: false,
  ordersError: null,
  detail: null,
  detailLoading: false,
  detailError: null,
  actionLoading: false,
  actionError: null,
  adminProducts: [],
  adminPages: [],
  adminVouchers: [],
  adminUsVouchers: [],
  adminIndiaVouchers: [],
  // {id,name} only — the product picker on the discounts pages.
  voucherProducts: [],
  adminLoading: false,
  adminError: null,
  adminSaving: false,
  adminSaveError: null,
  // Catalog CMS detail page. Kept separate from adminProducts on purpose: the list
  // and the detail load independently, and sharing one key lets a slow list
  // response overwrite a product the user just saved.
  adminProduct: null,
  adminProductLoading: false,
  adminProductError: null,
  adminProductSaving: false,
  // Per-field save outcomes. The engine has no bulk mutation, so one Save is N
  // calls and some can fail while others succeed — the UI needs to mark exactly
  // those cells rather than showing one blanket failure.
  adminProductSaveResults: [],
  adminProductSaveFailures: [],
};

export default function commerceAdmin(state = initial, action) {
  switch (action.type) {
    case CA_ORDERS_LOADING:
      return { ...state, ordersLoading: true, ordersError: null };
    case CA_ORDERS_SUCCESS: {
      const { connection, append } = action.payload;
      const edges = (connection.edges || []).map((e) => e.node);
      return {
        ...state,
        ordersLoading: false,
        orders: append ? [...state.orders, ...edges] : edges,
        pageInfo: connection.pageInfo || initial.pageInfo,
        totalCount: connection.totalCount || 0,
      };
    }
    case CA_ORDERS_FAIL:
      return { ...state, ordersLoading: false, ordersError: action.payload };

    case CA_ORDER_LOADING:
      return { ...state, detailLoading: true, detailError: null };
    case CA_ORDER_SUCCESS:
      return { ...state, detailLoading: false, detail: action.payload };
    case CA_ORDER_FAIL:
      return { ...state, detailLoading: false, detailError: action.payload };

    case CA_ACTION_LOADING:
      return { ...state, actionLoading: true, actionError: null };
    case CA_ACTION_SUCCESS:
      return { ...state, actionLoading: false };
    case CA_ACTION_FAIL:
      return { ...state, actionLoading: false, actionError: action.payload };

    case CA_ADMIN_LOADING:
      return { ...state, adminLoading: true, adminError: null };
    case CA_ADMIN_PRODUCTS:
      return { ...state, adminLoading: false, adminProducts: action.payload };
    case CA_ADMIN_PAGES:
      return { ...state, adminLoading: false, adminPages: action.payload };
    case CA_ADMIN_VOUCHERS:
      return { ...state, adminLoading: false, adminVouchers: action.payload };
    case CA_US_VOUCHERS:
      return { ...state, adminLoading: false, adminUsVouchers: action.payload };
    case CA_INDIA_VOUCHERS:
      return { ...state, adminLoading: false, adminIndiaVouchers: action.payload };
    case CA_VOUCHER_PRODUCTS:
      return { ...state, adminLoading: false, voucherProducts: action.payload };
    case CA_ADMIN_FAIL:
      return { ...state, adminLoading: false, adminError: action.payload };
    case CA_ADMIN_SAVING:
      return { ...state, adminSaving: true, adminSaveError: null };
    case CA_ADMIN_SAVED:
      return { ...state, adminSaving: false };
    case CA_ADMIN_SAVE_FAIL:
      return { ...state, adminSaving: false, adminSaveError: action.payload };

    case CA_PRODUCT_LOADING:
      return { ...state, adminProductLoading: true, adminProductError: null };
    case CA_PRODUCT_SUCCESS:
      return { ...state, adminProductLoading: false, adminProduct: action.payload };
    case CA_PRODUCT_FAIL:
      return { ...state, adminProductLoading: false, adminProductError: action.payload };
    case CA_PRODUCT_SAVING:
      // Clear previous outcomes so a stale failure cannot look like it belongs to
      // the save now in flight.
      return { ...state, adminProductSaving: true, adminProductSaveResults: [], adminProductSaveFailures: [] };
    case CA_PRODUCT_SAVED:
      return {
        ...state,
        adminProductSaving: false,
        adminProductSaveResults: action.payload.results || [],
        adminProductSaveFailures: action.payload.failures || [],
      };

    default:
      return state;
  }
}
